import { Typography, ListItemText, Link } from '@mui/material';
import List from '../styled/List';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';

const TechnicalRequirements = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      4. Wymagania techniczne oraz funkcjonalności serwisu.
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>4.1.</ListItemIcon>
        <ListItemText>
          W celu zapewnienia prawidłowego funkcjonowania Serwisu i Usług w
          przeglądarce internetowej stosowanej przez Użytkownika, a także dla
          bezpieczeństwa danych, Użytkownik powinien stosować się do wymagań
          technicznych wskazanych w tej części Regulaminu.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>4.2.</ListItemIcon>
        <ListItemText>
          Do korzystania z Serwisu niezbędne jest posiadanie urządzenia oraz
          oprogramowania pozwalającego na korzystanie z zasobów Internetu,
          umożliwiającego wyświetlanie stron www. Administrator zaleca:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                stosowanie najnowszej wersji przeglądarek internetowych takich
                jak: Google Chrome, Mozilla Firefox, Apple Safari lub Microsoft
                Edge,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b) </ListItemIcon>
              <ListItemText>
                posiadanie i dostęp do skrzynki poczty elektronicznej e–mail z
                założonym adresem e–mail Użytkownika.
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>4.3.</ListItemIcon>
        <ListItemText>
          Administrator umożliwia udostępnianie Dokumentów, będących w jego
          posiadaniu, związanych z istniejącym zobowiązaniem, na prośbę
          Użytkownika. Administrator zastrzega, że część Dokumentów będzie
          widoczna w Serwisie po zalogowaniu przez Klienta na jego Koncie.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>4.4.</ListItemIcon>
        <ListItemText>
          Użytkownik ma możliwość skierowania prośby o udostępnienie Dokumentu w
          ramach swojego Konta w Serwisie poprzez:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                rozmowę telefoniczną z konsultantem Contact Center podmiotu BEST
                S.A.,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b) </ListItemIcon>
              <ListItemText>
                wysyłkę korespondencji do Administratora na adres centrum
                usługowego BEST S.A. w Elblągu (ul. Stoczniowa 2, 82-300
                Elbląg),
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c) </ListItemIcon>
              <ListItemText>
                w ramach cyfrowego kanału komunikacji Chat,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>d) </ListItemIcon>
              <ListItemText>
                w ramach korespondencji mailowej kierowanej na adres:
                <Link
                  href="mailto:korespondencja@best.com.pl"
                  color="primary.light"
                  rel="nofollow"
                  data-link-no-alert
                >
                  korespondencja@best.com.pl
                </Link>
                .
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>4.5.</ListItemIcon>
        <ListItemText>
          Dokumenty są udostępniane do pobrania na Koncie Użytkownika w serwisie
          BEST Online. Celem udostępniania dokumentów w Serwisie jest
          optymalizacja czasu obsługi Użytkowników.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>4.6.</ListItemIcon>
        <ListItemText>
          Dokumenty co do zasady są udostępniane w trybie real-time
          (niezwłocznie po otrzymanej prośbie) w formacie PDF. W przypadku braku
          możliwości udostępnienia Dokumentu niezwłocznie Użytkownik jest
          informowany przez Administratora o terminie jego udostępnienia
          odrębnym mailem.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>4.7.</ListItemIcon>
        <ListItemText>
          Użytkownik w korespondencji mailowej otrzyma od Administratora
          informację o terminie zakończenia udostępniania dokumentu w Serwisie
          BEST Online.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>4.8.</ListItemIcon>
        <ListItemText>
          Użytkownik może otrzymać od Administratora wiadomość mailową o
          wycofaniu danego dokumentu z udostępniania w Serwisie BEST Online ze
          wskazaniem terminu wycofania dokumentu.
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default TechnicalRequirements;
